module.exports = __webpack_public_path__ + "img/Abecedario.3aea7fe9.svg";